import React from "react";
import { Play } from "lucide-react";
import { CardAnim1, CardAnim2 } from "../ItemsUI";

const HERO_IMG = "/mnt/data/Screenshot 2025-10-04 175418.png";

export default function HeroCard17() {
  return (
    <>
      <section className="gp-hero">
        <div className="gp-overlay" />

        <div className="gp-container">
          {/* LEFT SIDE */}
          <div className="gp-left">
            <div className="gp-badge">
              <span className="gp-dot" /> Gangsta Philosophy
            </div>

            <h1 className="gp-title">
              Becoming Warriors With <br />
              <span className="gp-title-highlight">Shwetabh Gangwar</span>
            </h1>

            <p classn="gp-desc">
              Become smarter, stronger, and better in every way. Courses integrating
              Psychology, Philosophy, and the science of motivation and productivity.
            </p>

            <div className="gp-cta-row">
              <button className="gp-btn-primary">Become a Member</button>

              <button className="gp-btn-secondary">
                <Play size={24} />
                Watch Video
              </button>
            </div>

            <div className="gp-social-proof">
              <div className="gp-avatars">
                <img src="https://i.pravatar.cc/40?img=1" alt="" />
                <img src="https://i.pravatar.cc/40?img=2" alt="" />
                <img src="https://i.pravatar.cc/40?img=3" alt="" />
                <img src="https://i.pravatar.cc/40?img=4" alt="" />
              </div>

              <div className="gp-metrics">
                <strong>15,000+</strong>
                <span>Happy Learners Worldwide</span>
              </div>

              <div className="gp-rating">
                <strong>4.8/5 ⭐</strong>
                <span>6000+ Reviews • Excellent</span>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="gp-right">
            <CardAnim1 id={"cmHC17"} mode ={"dark"} colors={{c1:"rgba(47, 42, 42, 1)",c2:"rgba(31, 29, 29, 1)"}} />
            {/* <img src={"https://i.postimg.cc/NjF4BFVz/red_haired_lady_eyeglasses_holds_books_shows_ok_sign_1_removebg_preview.png"} alt="hero" className="gp-img" /> */}
          </div>
        </div>
      </section>

      <style>{`
        .gp-hero {
          position: relative;
          min-height: 90vh;
          background: #0d0d0d;
          color: white;
          display: flex;
          align-items: center;
          padding: 10px 6%;
          overflow: hidden;
        }

        /* black textured overlay */
        .gp-overlay {
          position: absolute;
          inset: 0;
          background: url('https://www.transparenttextures.com/patterns/noise.png');
          opacity: 0.15;
          pointer-events: none;
        }

        .gp-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          max-width: 1400px;
          position: relative;
          z-index: 2;
        }

        /* LEFT SIDE */
        .gp-left {
          max-width: 500px;
        }

        .gp-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #1f1f1f;
          padding: 6px 14px;
          border-radius: 20px;
          font-size: 0.9rem;
          font-weight: 600;
          margin-bottom: 14px;
        }

        .gp-dot {
          width: 10px;
          height: 10px;
          background: #c8b888;
          border-radius: 50%;
          display: inline-block;
        }

        .gp-title {
          font-size: 3rem;
          font-weight: 800;
          line-height: 1.15;
        }

        .gp-title-highlight {
          color: #eac46f;
        }

        .gp-desc {
          margin-top: 14px;
          color: #cccccc;
          max-width: 550px;
          line-height: 1.6;
          font-size: 1.1rem;
          margin-bottom: 30px;
        }

        /* CTA BUTTONS */
        .gp-cta-row {
          display: flex;
          align-items: center;
          gap: 18px;
          margin-bottom: 28px;
        }

        .gp-btn-primary {
          background: #e53f3f;
          border: none;
          padding: 14px 32px;
          border-radius: 8px;
          font-size: 1.05rem;
          font-weight: 700;
          cursor: pointer;
          transition: 0.3s;
        }
        .gp-btn-primary:hover {
          background: rgba(255, 76, 76, 1);
        }

        .gp-btn-secondary {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 20px;
          border-radius: 50px;
          border: 2px solid white;
          background: transparent;
          font-size: 1.05rem;
          cursor: pointer;
          transition: 0.3s;
        }
        .gp-btn-secondary:hover {
          background: rgba(255,255,255,0.1);
        }

        /* Social Proof */
        .gp-social-proof {
          display: flex;
          align-items: center;
          gap: 25px;
          margin-top: 20px;
        }

        .gp-avatars {
          display: flex;
        }

        .gp-avatars img {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          margin-left: -10px;
          border: 2px solid white;
        }

        .gp-metrics,
        .gp-rating {
          display: flex;
          flex-direction: column;
          font-size: 0.9rem;
        }
        .gp-metrics strong,
        .gp-rating strong {
          font-size: 1.1rem;
        }

        /* RIGHT SIDE IMAGE */
        .gp-right {
          flex: 1;
          display: flex;position:relative;left:-50px;top:50px;
          justify-content: flex-start;
        }

        .gp-img {
          
          object-fit: contain;
          filter: brightness(0.95);
        }

        @media (max-width: 980px) {
          .gp-container {
            flex-direction: column-reverse;
            text-align: center;
          }
          .gp-right {
            justify-content: center;
            margin-bottom: 40px;
          }
          .gp-social-proof {
            justify-content: center;
          }
        }
      `}</style>
    </>
  );
}
